import styled from "styled-components";

const MenuColumnContainer = styled.div`
   border-radius: 16px;
   background-color: white;
   box-shadow: 0 0 20px rgb(0 0 0 / 8%);
`;

export default MenuColumnContainer;